import * as ng from 'angular';
import { BaseUrlService } from '../../../services/base-url.service';
import { ArchiSmallServices } from '../../../services/archismall.service';


class ScaricaDocumentiConservatiController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'ArchiSmallServices',
        'store'
    ];
    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private $http: ng.IHttpService,
        private configuration: any,
        private ArchiSmallServices: ArchiSmallServices,
        private store: ng.a0.storage.IStoreService
    ) {
        ArchiSmallServices.getUnsubscriptionArchives(2)
            .then((response: any) => {
                if ($rootScope.conservazioneArchives.length > 0) {
                    ng.forEach(response, (value, key) => {
                        let archiveExists = $rootScope.checkIfArchiveExists(value, 'conservazioneArchives');

                        if (!archiveExists) {
                            $rootScope.conservazioneArchives.unshift(value);
                        }
                    });
                } else {
                    $rootScope.conservazioneArchives = response;
                }
            }, (error) => {
                $rootScope.alert('error', error);
            });
        $scope.download = function () {
            $rootScope.downloadFile(this.archive.storage_file.storage_path, this.archive.storage_file.name);
        };

        $scope.setDownloadedStatus = function () {
            this.archive.downloaded = true;

            ArchiSmallServices.updateUnsubscriptionArchiveDownloadedStatus(this.archive)
                .then((response: any) => {
                    // ??
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
    }
}

export const ScaricaDocumentiConservatiComponent: ng.IComponentOptions = {
    template: require('./scarica-documenti-conservati.html'),
    controller: ScaricaDocumentiConservatiController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/scarica-documenti-conservati/scarica-documenti-conservati.ts